/**
 * Eager-first-6 — above-fold directory thumbs (Organizace / Obchody lists).
 * First 6 visible rows: loading=eager + fetchPriority=high; rest lazy.
 */

export const DIRECTORY_THUMB_EAGER_COUNT = 6;

export type DirectoryThumbLoading = 'eager' | 'lazy';
export type DirectoryThumbFetchPriority = 'high' | 'low' | 'auto';

export function directoryThumbLoading(index: number): DirectoryThumbLoading {
  return index < DIRECTORY_THUMB_EAGER_COUNT ? 'eager' : 'lazy';
}

export function directoryThumbFetchPriority(
  index: number,
): DirectoryThumbFetchPriority | undefined {
  return index < DIRECTORY_THUMB_EAGER_COUNT ? 'high' : undefined;
}
